import { enums } from "..";

enum EBinanceTimeframes {
  minute = '1m',
  threeMinutes = '3m',
  fiveMinute = '5m',
  fifteenMinutes = '15m',
  thirtyMinutes = '30m',
  hour = '1h',
  twoHours = '2h',
  fourHours = '4h',
  sixHours = '6h',
  eightHours = '8h',
  twelveHours = '12h',
  day = '1d',
  threeDays = '3d',
  week = '1w',
  month = '1M',
  quarter = 'quarter',
  year = 'year',
}

const binanceResolutionFormatter = (resolution: string): EBinanceTimeframes => {
  switch (resolution) {
  case '1':
    return EBinanceTimeframes.minute;
  case '3':
    return EBinanceTimeframes.threeMinutes;
  case '5':
    return EBinanceTimeframes.fiveMinute;
  case '15':
    return EBinanceTimeframes.fifteenMinutes;
  case '30':
    return EBinanceTimeframes.thirtyMinutes;
  case '60':
    return EBinanceTimeframes.hour;
  case '120':
    return EBinanceTimeframes.twoHours;
  case '240':
    return EBinanceTimeframes.fourHours;
  case '360':
    return EBinanceTimeframes.sixHours;
  case '480':
    return EBinanceTimeframes.eightHours;
  case '720':
    return EBinanceTimeframes.twelveHours;
  case '1440':
  case 'D':
  case '1D':
  case '1d':
    return EBinanceTimeframes.day;
  case '3D':
    return EBinanceTimeframes.threeDays;
  case 'W':
  case '1W':
    return EBinanceTimeframes.week;
  case 'M':
  case '1M':
    return EBinanceTimeframes.month;
  default:
    return EBinanceTimeframes.hour;
  }
};

const shortResolutionFormatter = (resolution: string): enums.ETimeframes => {
  switch (resolution) {
  case '1S':
    return enums.ETimeframes.oneSecond;
  case '5S':
    return enums.ETimeframes.fiveSeconds;
  case '10S':
    return enums.ETimeframes.tenSeconds;
  case '1':
    return enums.ETimeframes.minute;
  case '3':
    return enums.ETimeframes.threeMinutes;
  case '5':
    return enums.ETimeframes.fiveMinute;
  case '15':
    return enums.ETimeframes.fifteenMinutes;
  case '30':
    return enums.ETimeframes.thirtyMinutes;
  case '60':
    return enums.ETimeframes.hour;
  case '120':
    return enums.ETimeframes.twoHours;
  case '240':
    return enums.ETimeframes.fourHours;
  case '360':
    return enums.ETimeframes.sixHours;
  case '480':
    return enums.ETimeframes.eightHours;
  case '720':
    return enums.ETimeframes.twelveHours;
  case '1440':
  case 'D':
  case '1D':
    return enums.ETimeframes.day;
  case '3D':
    return enums.ETimeframes.threeDays;
  case 'W':
  case '1W':
    return enums.ETimeframes.week;
  case 'M':
  case '1M':
    return enums.ETimeframes.month;
  default:
    return enums.ETimeframes.hour;
  }
};

const longResolutionFormatter = (resolution: any): string => {
  switch (resolution) {
  case '1S':
    return '1 second';
  case '5S':
    return '5 seconds';
  case '10S':
    return '10 seconds';
  case '1':
    return '1 minute';
  case '3':
    return '3 minutes';
  case '5':
    return '5 minutes';
  case '15':
    return '15 minutes';
  case '30':
    return '30 minutes';
  case '60':
    return '1 hour';
  case '120':
    return '2 hours';
  case '240':
    return '4 hours';
  case '360':
    return '6 hours';
  case '480':
    return '8 hours';
  case '720':
    return '12 hours';
  case '1440':
    return '24 hours';
  case 'D':
    return '1 day';
  case '1D':
    return '1 day';
  case '3D':
    return '3 days';
  case 'W':
    return '1 week';
  case '1W':
    return '1 week';
  case 'M':
    return '1 month';
  case '1M':
    return '1 month';
  default:
    return resolution;
  }
};

export {
  EBinanceTimeframes,
  shortResolutionFormatter,
  longResolutionFormatter,
  binanceResolutionFormatter
};
